module.exports = __webpack_public_path__ + "img/vertical_4_4_7005.96f1c994.png";